import moment from 'moment';

// Calendar strings have no timezone. Date objects retain the calendar's local fields.
export const displayDate = (value, language = 'pl') => {
  if (!value) return '';
  const date = value instanceof Date ? moment(value) : moment(value, 'YYYY-MM-DD', true);
  return date.isValid() ? date.format(language === 'en' ? 'DD/MM/YYYY' : 'DD.MM.YYYY') : String(value);
};

// Preserve the stored timestamp's offset and clock time; presentation does not move it.
export const displayDateTime = (value, language = 'pl') => {
  if (!value) return '';
  const date = value instanceof Date ? moment(value) : moment.parseZone(value, moment.ISO_8601, true);
  return date.isValid() ? date.format(language === 'en' ? 'DD/MM/YYYY HH:mm' : 'DD.MM.YYYY HH:mm') : String(value);
};
